import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const openDisableAdsPromo = (data) => openPopupHelper({ popupName: popupNames.DISABLE_ADS_PROMO, data });